/* global rp$, globalThis */
'use strict';

const { handleGarageData } = require('public/js/components/garage-store.js');
const utils = require('public/js/helpers/utils');

var THE_SCRIPT = function() {
	const $onReady = require('public/js/lib/on-ready');

	function redirectOrReloadFromGarageResponse(data) {
		handleGarageData.clearGarageCache();
		const redirectUrl = data?.redirect_url;
		if (redirectUrl) {
			if (typeof globalThis.rp_app?.location?.redirect === 'function') {
				globalThis.rp_app.location.redirect(redirectUrl);
			} else {
				globalThis.location.href = redirectUrl;
			}
		} else {
			globalThis.location.reload();
		}
	}

	function removeCarFromGarage(evt) {
		const closeIcon = evt.target.closest('.car-close-icon');
		if (!closeIcon) {
			return;
		}

		const carHash = closeIcon.getAttribute('data-car-hash');
		if (!carHash) {
			return;
		}

		const page = globalThis.rp_app?.env?.page ?? '';
		const path = globalThis.rp_app?.location?.pathname ?? '';
		const variables = { carHash, page, path };

		closeIcon.classList.add('loading');
		const icon = closeIcon.querySelector('i');
		const spinner = document.createElement('div');
		spinner.className = 'loading-spinner';
		if (icon) {
			icon.appendChild(spinner);
		}

		evt.preventDefault();
		evt.stopPropagation();

		$ajax({
			method: 'post',
			url: '/ajax/garage/remove-car',
			data: variables,
			dataType: 'json',
			success: redirectOrReloadFromGarageResponse,
			complete: function () {
				closeIcon.classList.remove('loading');
				const loadingSpinner = icon?.querySelector('.loading-spinner');
				if (loadingSpinner) {
					loadingSpinner.remove();
				}
			}
		});
	}

	function selectCarFromGarage(evt) {
		if (evt.target.closest('.car-close-icon')) {
			return;
		}

		const $link = rp$(evt.currentTarget);
		if (!$link.hasClass('recent-car')) {
			return;
		}

		const year = $link.data('year');
		const make = $link.data('make');
		const model = $link.data('model');
		const trim = $link.data('trim') ?? '';
		const engine = $link.data('engine') ?? '';
		const page = globalThis.rp_app?.env?.page ?? '';
		const path = globalThis.rp_app?.location?.pathname ?? '';

		if (!year || !make || !model) {
			return;
		}

		const variables = {
			year: year,
			make: make,
			model: model,
			trim: trim,
			engine: engine,
			page: page,
			path: path
		};

		evt.preventDefault();
		evt.stopPropagation();

		$ajax({
			method: 'post',
			url: '/ajax/vehicle-picker/select',
			data: variables,
			dataType: 'json',
			success: redirectOrReloadFromGarageResponse
		});
	}

	function clearVehicleFromSearch(evt) {
		const page = globalThis.rp_app?.env?.page ?? '';
		const path = globalThis.rp_app?.location?.pathname ?? '';
		const variables = { page: page, path: path };

		evt.preventDefault();
		evt.stopPropagation();

		$ajax({
			method: 'post',
			url: '/ajax/garage/search-all-cars',
			data: variables,
			dataType: 'json',
			success: redirectOrReloadFromGarageResponse
		});
	}

	function clearAllVehiclesFromGarage(evt) {
		const page = globalThis.rp_app?.env?.page ?? '';
		const path = globalThis.rp_app?.location?.pathname ?? '';
		const variables = { page: page, path: path };

		evt.preventDefault();
		evt.stopPropagation();

		$ajax({
			method: 'post',
			url: '/ajax/garage/clear-all-cars',
			data: variables,
			dataType: 'json',
			success: redirectOrReloadFromGarageResponse
		});
	}

	function handleGarageListItems(eventOrGarage, maybeGarage, ...rest) {
		const garage = utils.normalizeEventPayloadArgs(eventOrGarage, maybeGarage, rest);
		if (garage.length === 0) {
			return;
		}
		const containerComponents = document.querySelectorAll('.garage-list-items-container');
		if (!containerComponents.length) {
			return;
		}

		containerComponents.forEach((container) => {
			const templateContainer = container.nextElementSibling;
			if (!templateContainer?.classList?.contains('garage-list-items-template')) {
				return;
			}
			const template = templateContainer.querySelector('li');
			if (!template) {
				return;
			}
			container.innerHTML = '';

			const orderedGarage = garage
				.filter((car) => car && typeof car === 'object' && car.selected)
				.concat(garage.filter((car) => !car || typeof car !== 'object' || !car.selected));

			orderedGarage.forEach((car) => {
				const clone = template.cloneNode(true);
				clone.style.display = '';
				clone.classList.remove('garage-item-template');

				const link = clone.querySelector('.recent-car');
				const closeIcon = clone.querySelector('.car-close-icon');
				if (!link || !closeIcon) {
					return;
				}

				link.dataset.year = car.year;
				link.dataset.make = car.make;
				link.dataset.model = car.model;
				link.dataset.trim = car.trim ?? '';
				link.dataset.engine = car.engine ?? '';

				const icon = clone.querySelector('.car-first-icon');
				if (car.selected) {
					clone.classList.add('car-selected');
					icon.querySelector('span').style.display = '';
				} else {
					icon.querySelector('span').style.display = 'none';
				}

				let path = utils.buildVehicleBasePath(car);
				if (!path) {
					return;
				}

				if (typeof link.dataset.browseSuffix === 'string' && link.dataset.browseSuffix !== '') {
					path += link.dataset.browseSuffix;
				}
				link.setAttribute('href', path);

				const label = clone.querySelector('.car-label');
				label.textContent = car.ui_short;
				closeIcon.dataset.carHash = car.hash;
				closeIcon.dataset.path = path;

				container.appendChild(clone);
			});
		});
	}

	function attachEvents() {
		if (!handleGarageData || typeof handleGarageData.getGarageData !== 'function') {
			return;
		}

		rp$(document)
			.off('garageUpdated.garageListItems')
			.on('garageUpdated.garageListItems', handleGarageListItems);

		const containerComponent = document.querySelector('.garage-list-items-container');
		const isVehicleSpecificPage = utils.isTruthyDataValue(containerComponent?.dataset?.isVehicleSpecificPage);
		const garage = handleGarageData.getGarageData(isVehicleSpecificPage);
		if (garage) {
			handleGarageListItems(garage);
		}
	}

	(function GarageComponent() {
		$onReady({
			rp$,
			window: globalThis,
			label: 'garage_component',
			fn: function() {
				attachEvents();
				rp$('.garage.flyout').on('click', '.car-close-icon', removeCarFromGarage);
				rp$('.garage.flyout').on('click', '.recent-car', selectCarFromGarage);
				rp$('.garage.flyout').on('click', '.search-all-vehicles', clearVehicleFromSearch);
				rp$('.garage.flyout').on('click', '.clear-all-vehicles', clearAllVehiclesFromGarage);
			}
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
